// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 1l4 4 4-4%27 stroke=%27%236a5e58%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   DataFittingPage.css  —  KinetiQ Data Fitting Page
   Tracker #8:  increased font sizes & spacing throughout
   Tracker #9:  tooltip styles (1-second hover delay)
   Tracker #10: full-name field labels
   Tracker #11: math subscript/superscript notation
   Tracker #13: fitted rate equation display
   ============================================================ */

/* ─── Google Fonts ─────────────────────────────────────────── */

/* ─── Design tokens ─────────────────────────────────────────── */
/* NOTE: color tokens (--color-*) are defined per-theme further down
   in the "Dark theme (default)" / "Light theme" blocks, so that
   switching data-theme on <html> re-themes the whole app. Only
   theme-neutral tokens live in this :root block. */
:root {
  /* Fitting-mode card colors (same across themes) — aligned to the
     KinetiQ landing-page brand palette (blue / teal / accent). */
  --color-mode-keq:     #1A3C6E;   /* kinetic-blue */
  --color-mode-kb:      #8b55db;
  --color-mode-unit:    #e07ba0;
  --color-mode-lhhw:    #00C2A8;   /* kinetic-accent */

  /* Typography — Tracker #8: larger base font */
  --font-mono:   'Inter', 'JetBrains Mono', 'Fira Code', monospace;
  --font-ui:     'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --font-brand:  'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --font-serif:  'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;

  /* Spacing scale — Tracker #8: generously increased */
  --space-xs:    6px;
  --space-sm:    10px;
  --space-md:    16px;
  --space-lg:    24px;
  --space-xl:    36px;

  /* Border radius */
  --radius-sm:   6px;
  --radius-md:   10px;
  --radius-lg:   14px;

  /* Sidebar offset (must match Sidebar width) */
  --sidebar-w:   242px;

  /* Font-size scale — replaces ad-hoc inline fontSize:10/11 values.
     Nothing in the app should go below --fs-xs (12px). */
  --fs-xs:   12px;   /* table cells, dense data grids, footnotes */
  --fs-sm:   13px;   /* field labels, secondary/help text */
  --fs-base: 15px;   /* body text, inputs */
  --fs-lg:   18px;   /* section headers */
  --fs-xl:   22px;   /* panel / page titles */
}

/* ─── Dark theme (default) ──────────────────────────────────────
   Client decision: dark background + white font on the main panel,
   sidebar was already dark. Avoid pairing dark bg with coloured
   font — text stays white/near-white. Light theme remains available
   via the theme toggle (data-theme="light" on <html>). ────────── */
:root,
[data-theme="dark"] {
  /* Backgrounds — deep navy family, matching kinetic-dark (#0D1F35) from
     the KinetiQ landing page instead of the previous slate/graphite tones. */
  --color-bg:           #0B1826;
  --color-surface:      #0F2135;
  --color-panel:        #142A44;
  --color-card:         #12253D;
  --color-shell:        #0d1a2c00;
  --color-nav:          #081422;
  --color-code-bg:      #081420;

  /* Brand accent — kinetic-accent teal-green, matches the landing-page
     CTA / highlight color (was a plain green, #34c15e). */
  --color-accent:       #00C2A8;
  --color-accent-dim:   rgba(0, 194, 168, 0.14);
  --color-accent-glow:  rgba(0, 194, 168, 0.32);
  --color-accent-hover: #00A88F;

  --color-success:      #2FBE84;
  --color-success-dim:  rgba(47, 190, 132, 0.14);
  --color-warning:      #F4A261;
  --color-warning-dim:  rgba(244, 162, 97, 0.16);
  --color-warning-dark: #F4A261;
  --color-error:        #f2555a;
  --color-error-dim:    rgba(242, 85, 90, 0.16);
  --color-cyan:         #2FB9D9;
  --color-cyan-dim:     rgba(47, 185, 217, 0.14);
  --color-purple:       #a97bf0;

  /* Unified toggle-pill color — kinetic-teal, matches the landing page's
     secondary brand color so toggles read as part of the same system. */
  --color-toggle:       #0B8DA6;
  --color-toggle-dim:   rgba(11, 141, 166, 0.18);
  --color-toggle-glow:  rgba(11, 141, 166, 0.38);

  --color-border:       #1F3350;
  --color-border-light: #2A415F;
  --color-border-mid:   #17263D;

  --color-text:         #F0F7FA;
  --color-text-muted:   #93A9BC;
  --color-text-mid:     #B9CBD8;
  --color-text-dim:     #64768A;

  --color-tab-active:   #00C2A8;
  --color-tab-hover:    #16283F;
  --color-nav-active:   rgba(0, 194, 168, 0.16);
  --color-input-bg:     #0D1F32;
  --color-input-border: #1F3350;
  --color-tag:          #2FB9D9;
}

/* ─── Light theme (opt-in via toggle) ───────────────────────────── */
[data-theme="light"] {
  /* Light theme now mirrors the KinetiQ landing page directly:
     --kinetic-light bg, white cards, blue headings, teal/accent CTAs. */
  --color-bg:           #F0F7FA;
  --color-surface:      #FFFFFF;
  --color-panel:        #E3F2F0;
  --color-card:         #FFFFFF;
  --color-shell:        #F5FAFB;
  --color-nav:          #EAF3F6;
  --color-code-bg:      #F7FBFC;

  --color-accent:       #00C2A8;
  --color-accent-dim:   rgba(0, 194, 168, 0.10);
  --color-accent-glow:  rgba(0, 194, 168, 0.25);
  --color-accent-hover: #049885;

  --color-success:      #1E9E6C;
  --color-success-dim:  rgba(30, 158, 108, 0.10);
  --color-warning:      #E8973F;
  --color-warning-dim:  rgba(232, 151, 63, 0.12);
  --color-warning-dark: #C66A2E;
  --color-error:        #e03535;
  --color-error-dim:    rgba(224, 53, 53, 0.10);
  --color-cyan:         #0B8DA6;
  --color-cyan-dim:     rgba(11, 141, 166, 0.10);
  --color-purple:       #8b55db;

  --color-toggle:       #0B8DA6;
  --color-toggle-dim:   rgba(11, 141, 166, 0.10);
  --color-toggle-glow:  rgba(11, 141, 166, 0.28);

  --color-border:       #D6E4EC;
  --color-border-light: #E8F1F6;
  --color-border-mid:   #C3D6E0;

  --color-text:         #0D1F35;
  --color-text-muted:   #6B7A8D;
  --color-text-mid:     #45566A;
  --color-text-dim:     #A8B8C4;

  --color-tab-active:   #00C2A8;
  --color-tab-hover:    #E3F2F0;
  --color-nav-active:   rgba(0, 194, 168, 0.12);
  --color-input-bg:     #ffffff;
  --color-input-border: #D6E4EC;
  --color-tag:          #0B8DA6;
}

/* Smooth theme switch */
html { transition: background-color 160ms ease; }
* { transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease; }

/* ─── Global Reset ───────────────────────────────────────────── */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body {
  background:   var(--color-bg);
  color:        var(--color-text);
  height:       100%;
  overflow:     hidden;
  font-family:  var(--font-ui);
  font-size:    16px;   /* Aligned with TutorialsDashboard Inter base */
  line-height:  1.65;
}

/* Guard against parent layout/router wrappers (e.g. #root, #app) that
   don't inherit height/overflow constraints — without this, the page
   can grow taller than the viewport and the *browser* scrolls instead
   of the intended internal panels, hiding the top nav under the fold. */
#root,
#app {
  height:   100%;
  overflow: hidden;
}

/* ─── Scrollbar ──────────────────────────────────────────────── */
::-webkit-scrollbar        { width: 5px; height: 5px; }
::-webkit-scrollbar-track  { background: transparent; }
::-webkit-scrollbar-thumb  { background: var(--color-border); border-radius: 3px; }
::-webkit-scrollbar-thumb:hover { background: var(--color-border-mid); }

/* ─── KaTeX equation blocks — no scroll ─────────────────────────
   react-katex's <BlockMath> renders a \`.katex-display\` span, and KaTeX's
   own stylesheet gives that element \`overflow-x: auto\` by default — this
   is what was actually producing the left/right scrollbar under the Rate
   Equation / Arrhenius / Expressions-used boxes, independent of any
   overflow setting on our own wrapping <div>. Force it off everywhere. */
.katex-display {
  overflow-x: visible !important;
  overflow-y: visible !important;
}
.katex-display::-webkit-scrollbar { display: none; height: 0; width: 0; }

/* ─── Number input — hide spin buttons ──────────────────────── */
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button { -webkit-appearance: none; }
input[type='number']                             { -moz-appearance: textfield; }

/* ─── Select option theming ─────────────────────────────────── */
select option {
  background: var(--color-surface);
  color:      var(--color-text);
}

/* ─── Focus rings ────────────────────────────────────────────── */
button:focus-visible,
input:focus-visible,
select:focus-visible {
  outline:        2px solid var(--color-accent);
  outline-offset: 2px;
}

/* ─── Sidebar layout offset ─────────────────────────────────── */
.df-page-root {
  margin-left: var(--sidebar-w);
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ─── Panel shell ────────────────────────────────────────────── */
.df-shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--color-shell);
}

/* ─── Top nav bar ────────────────────────────────────────────── */
.df-nav {
  display: flex;
  align-items: center;
  gap: var(--space-xs);
  padding: 10px 20px;  /* Tracker #8 */
  background: var(--color-nav);
  border-bottom: 1px solid var(--color-border);
  flex-shrink: 0;
  overflow-x: auto;
}

.df-nav-tab {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 18px;  /* Tracker #6 & #8 */
  border-radius: var(--radius-sm);
  border: 1px solid transparent;
  background: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  font-family: var(--font-ui);
  color: var(--color-text-muted);
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  white-space: nowrap;
  text-decoration: none;
}
.df-nav-tab:hover {
  background: var(--color-tab-hover);
  color: var(--color-text);
}
.df-nav-tab--active {
  background: var(--color-nav-active);
  color: var(--color-accent);
  font-weight: 600;
  border-color: rgba(40, 167, 69, 0.25);
}

/* ─── Main content area ──────────────────────────────────────── */
.df-content {
  flex: 1 1;
  overflow-y: auto;
  padding: var(--space-lg) var(--space-lg);  /* Tracker #8 */
}

/* ─── Panel cards ────────────────────────────────────────────── */
.df-panel {
  background: var(--color-card);
  border: 1px solid var(--color-border-light);
  border-radius: var(--radius-lg);
  padding: var(--space-lg);  /* Tracker #8 */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: var(--space-lg);
  animation: fadeIn 0.25s ease;
}

.df-panel-title {
  font-family: var(--font-ui);
  font-size: 17px;
  font-weight: 700;
  color: var(--color-text);
  letter-spacing: -0.1px;
  margin-bottom: var(--space-md);
}

.df-panel-subtitle {
  font-size: 14px;
  font-weight: 400;
  color: var(--color-text-muted);
  margin-bottom: var(--space-lg);
  line-height: 1.65;
}

/* ─── Form fields — Tracker #8: increased label size & spacing ── */
.df-field-group {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  margin-bottom: var(--space-md);
}

.df-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-mid);
  letter-spacing: 0.01em;
  font-family: var(--font-ui);
}

/* ─────────────────────────────────────────────────────────────
   Tooltip system — Tracker #9
   1-second hover delay for all [data-tooltip] elements
───────────────────────────────────────────────────────────── */
[data-tooltip] {
  position: relative;
  cursor: help;
}
[data-tooltip]::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) scale(0.9);
  background: #1a2332;
  color: #cdd9e5;
  font-size: 13px;
  font-family: var(--font-ui);
  font-weight: 400;
  line-height: 1.45;
  padding: 7px 12px;
  border-radius: 7px;
  white-space: pre-wrap;
  max-width: 260px;
  min-width: 120px;
  text-align: center;
  pointer-events: none;
  z-index: 1000;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.08);
  /* 1-second delay per Tracker #9 */
  opacity: 0;
  transition: opacity 0.15s ease, transform 0.15s ease;
  transition-delay: 0s;
}
[data-tooltip]::before {
  content: '';
  position: absolute;
  bottom: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #1a2332;
  pointer-events: none;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.15s ease;
  transition-delay: 0s;
}
[data-tooltip]:hover::after {
  opacity: 1;
  transform: translateX(-50%) scale(1);
  transition-delay: 1s;  /* Tracker #9: 1-second delay */
}
[data-tooltip]:hover::before {
  opacity: 1;
  transition-delay: 1s;  /* Tracker #9: 1-second delay */
}

/* ─────────────────────────────────────────────────────────────
   Math notation — Tracker #11
   Subscripts & superscripts for rate equations
   e.g. kf, xa
───────────────────────────────────────────────────────────── */
.df-math {
  font-family: var(--font-ui);
  font-size: 14px;
  color: var(--color-text);
  display: inline-flex;
  align-items: baseline;
  gap: 1px;
}
.df-math sub {
  font-size: 0.72em;
  vertical-align: sub;
  line-height: 0;
}
.df-math sup {
  font-size: 0.72em;
  vertical-align: super;
  line-height: 0;
}
.df-math-block {
  font-family: var(--font-ui);
  font-size: 14px;
  background: var(--color-code-bg);
  border: 1px solid var(--color-border-light);
  border-radius: var(--radius-sm);
  padding: 10px 14px;
  color: var(--color-text);
  line-height: 1.8;
  overflow-x: auto;
}
.df-math-block sub { font-size: 0.72em; vertical-align: sub;   line-height: 0; }
.df-math-block sup { font-size: 0.72em; vertical-align: super; line-height: 0; }

/* ─────────────────────────────────────────────────────────────
   Fitted rate equation display — Tracker #13
   Shows model form + fitted parameter values together
───────────────────────────────────────────────────────────── */
.df-rate-equation-card {
  background: linear-gradient(135deg, rgba(40, 167, 69, 0.06) 0%, rgba(10, 181, 226, 0.04) 100%);
  border: 1px solid rgba(40, 167, 69, 0.22);
  border-radius: var(--radius-md);
  padding: var(--space-md) var(--space-lg);
  margin-bottom: var(--space-md);
  position: relative;
  overflow: hidden;
}
.df-rate-equation-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 3px;
  background: var(--color-accent);
  border-radius: 3px 0 0 3px;
}
.df-rate-equation-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-accent);
  font-family: var(--font-ui);
  margin-bottom: 8px;
}
.df-rate-equation-formula {
  font-family: var(--font-ui);
  font-size: 15px;
  color: var(--color-text);
  line-height: 2;
  letter-spacing: 0.01em;
}
.df-rate-equation-formula sub { font-size: 0.72em; vertical-align: sub;   line-height: 0; }
.df-rate-equation-formula sup { font-size: 0.72em; vertical-align: super; line-height: 0; }

.df-param-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: var(--space-sm);
  font-size: 14px;
  font-family: var(--font-ui);
}
.df-param-table th {
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--color-text-muted);
  padding: 8px 12px;
  border-bottom: 1px solid var(--color-border);
}
.df-param-table td {
  padding: 9px 12px;  /* Tracker #8 */
  border-bottom: 1px solid var(--color-border-light);
  vertical-align: middle;
  color: var(--color-text);
}
.df-param-table tr:hover td { background: rgba(40, 167, 69, 0.04); }
.df-param-value {
  font-family: var(--font-ui);
  font-size: 14px;
  color: var(--color-accent);
  font-weight: 600;
}

/* ─── Inputs ──────────────────────────────────────────────────── */
.df-input {
  width: 100%;
  padding: 9px 12px;  /* Tracker #8 */
  background: var(--color-input-bg);
  border: 1px solid var(--color-input-border);
  border-radius: var(--radius-sm);
  font-size: 14px;
  font-family: var(--font-ui);
  color: var(--color-text);
  transition: border-color 0.15s, box-shadow 0.15s;
  outline: none;
}
.df-input:focus {
  border-color: var(--color-accent);
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.12);
}

.df-select {
  appearance: none;
  width: 100%;
  padding: 9px 34px 9px 12px;
  background: var(--color-input-bg) url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 12px center;
  border: 1px solid var(--color-input-border);
  border-radius: var(--radius-sm);
  font-size: 14px;
  font-family: var(--font-ui);
  color: var(--color-text);
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.df-select:focus {
  border-color: var(--color-accent);
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.12);
}

/* ─── Buttons ────────────────────────────────────────────────── */
.df-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 18px;  /* Tracker #8 */
  border-radius: var(--radius-sm);
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  font-family: var(--font-ui);
  letter-spacing: 0.01em;
  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s, transform 0.1s;
  white-space: nowrap;
  outline: none;
}
.df-btn:active { transform: scale(0.98); }

.df-btn--primary {
  background: var(--color-accent);
  color: #fff;
  border-color: var(--color-accent);
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.28);
}
.df-btn--primary:hover {
  background: var(--color-accent-hover);
  border-color: var(--color-accent-hover);
  box-shadow: 0 4px 14px rgba(40, 167, 69, 0.36);
}

.df-btn--secondary {
  background: var(--color-surface);
  color: var(--color-text-mid);
  border-color: var(--color-border);
}
.df-btn--secondary:hover {
  background: var(--color-nav);
  border-color: var(--color-border-mid);
  color: var(--color-text);
}

/* Tracker #3: renamed 'Auto-fill from Previous Run' */
.df-btn--autofill {
  background: rgba(40, 167, 69, 0.08);
  color: var(--color-accent);
  border-color: rgba(40, 167, 69, 0.25);
}
.df-btn--autofill:hover {
  background: rgba(40, 167, 69, 0.14);
  border-color: rgba(40, 167, 69, 0.4);
}

/* ─── Fitting mode cards ─────────────────────────────────────── */
.df-mode-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: var(--space-md);  /* Tracker #8 */
  margin-bottom: var(--space-lg);
}

.df-mode-card {
  padding: var(--space-md);
  border-radius: var(--radius-md);
  border: 1.5px solid var(--color-border-light);
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
  position: relative;
  overflow: hidden;
  background: var(--color-card);
}
.df-mode-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}
.df-mode-card--active {
  border-color: var(--color-accent);
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.12);
}
.df-mode-card-name {
  font-size: 14px;
  font-weight: 600;
  font-family: var(--font-ui);
  margin-bottom: 4px;
}
.df-mode-card-desc {
  font-size: 13px;
  color: var(--color-text-muted);
  line-height: 1.4;
}

/* ─────────────────────────────────────────────────────────────
   Reaction type toggle — Tracker #17
   Reversible / Irreversible
───────────────────────────────────────────────────────────── */
.df-reaction-toggle {
  display: flex;
  gap: var(--space-sm);
  margin-bottom: var(--space-md);
}

.df-reaction-toggle-btn {
  flex: 1 1;
  padding: 10px 16px;
  border-radius: var(--radius-sm);
  border: 1.5px solid var(--color-border);
  background: var(--color-surface);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  font-family: var(--font-ui);
  color: var(--color-text-muted);
  text-align: center;
  transition: all 0.15s;
}
.df-reaction-toggle-btn:hover {
  border-color: var(--color-accent);
  color: var(--color-accent);
  background: var(--color-accent-dim);
}
.df-reaction-toggle-btn--active {
  background: var(--color-accent-dim);
  border-color: var(--color-accent);
  color: var(--color-accent);
  font-weight: 600;
  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.12);
}

/* ─────────────────────────────────────────────────────────────
   NIST component search row — Tracker #18 & #19
───────────────────────────────────────────────────────────── */
.df-nist-row {
  display: flex;
  gap: var(--space-sm);
  align-items: flex-end;
  flex-wrap: wrap;
  margin-bottom: var(--space-md);
}
.df-nist-badge {
  font-size: 13px;
  font-family: var(--font-ui);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 3px 8px;
  border-radius: 4px;
  background: var(--color-cyan-dim);
  color: var(--color-cyan);
  border: 1px solid rgba(10, 181, 226, 0.25);
}

/* ─── Graphs / Plots ──────────────────────────────────────────── */
.df-graph-container {
  background: var(--color-surface);
  border: 1px solid var(--color-border-light);
  border-radius: var(--radius-md);
  padding: var(--space-md);
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

/* ─── Status / info tags ────────────────────────────────────────  */
.df-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 700;
  font-family: var(--font-ui);
  padding: 3px 9px;
  border-radius: 5px;
  letter-spacing: 0.03em;
}
.df-tag--success { background: var(--color-success-dim); color: var(--color-success); }
.df-tag--warning { background: var(--color-warning-dim); color: var(--color-warning-dark); }
.df-tag--error   { background: var(--color-error-dim);   color: var(--color-error);   }
.df-tag--info    { background: var(--color-cyan-dim);    color: var(--color-cyan);    }
.df-tag--purple  { background: rgba(139, 85, 219, 0.10); color: var(--color-purple);  }

/* ─── Appendix — Tracker #5: remove petBOA/OpenMKM from main UI ─ */
/* These are shown only in the appendix section */
.df-appendix-footnote {
  font-size: 13px;
  color: var(--color-text-muted);
  font-family: var(--font-ui);
  padding: var(--space-md);
  border: 1px solid var(--color-border-light);
  border-radius: var(--radius-sm);
  background: var(--color-shell);
  margin-top: var(--space-md);
  line-height: 1.6;
}
.df-appendix-footnote strong {
  color: var(--color-text-mid);
}

/* ─── Reaction Rate Constants label — Tracker #2 ─────────────── */
.df-rrc-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--color-text-muted);
  font-family: var(--font-ui);
  margin-bottom: var(--space-sm);
}
.df-rrc-badge::after {
  content: 'Compatible with Aspen, DWSim';
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.03em;
  color: var(--color-text-dim);
  background: var(--color-shell);
  border: 1px solid var(--color-border-light);
  border-radius: 4px;
  padding: 2px 7px;
  text-transform: none;
}

/* ─── Divider ─────────────────────────────────────────────────── */
.df-divider {
  height: 1px;
  background: var(--color-border-light);
  margin: var(--space-md) 0;
}

/* ─── Grid helpers ───────────────────────────────────────────── */
.df-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: var(--space-md); }
.df-grid-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: var(--space-md); }

@media (max-width: 860px) {
  .df-grid-2,
  .df-grid-3 { grid-template-columns: 1fr; }
}

/* ─── Reset / Stop / Run Fitting action row ─────────────────────
   Sits in a single flex row (see DataFittingPage.jsx) that already
   wraps on its own via flex-wrap; these rules just make each button
   shrink and reflow cleanly instead of overflowing on small screens,
   and let "Run Fitting" grow to fill the row once it wraps alone. */
.df-fit-actions {
  row-gap: 8px;
}
@media (max-width: 640px) {
  .df-fit-btn {
    flex: 1 1 auto;
    font-size: 11px !important;
    padding: 6px 10px !important;
  }
}
@media (max-width: 480px) {
  .df-fit-actions {
    width: 100%;
    justify-content: stretch;
  }
  .df-fit-btn {
    flex: 1 1 30%;
    min-width: 0;
    text-align: center;
  }
  .df-fit-btn-run {
    flex-basis: 100%;
    order: 3;
  }
}

/* ─── Loading spinner ─────────────────────────────────────────── */
.df-spinner {
  width: 22px;
  height: 22px;
  border: 2.5px solid var(--color-border);
  border-top-color: var(--color-accent);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  display: inline-block;
}

/* ─── Animations ─────────────────────────────────────────────── */
@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes pulse-dot {
  0%,  100% { opacity: 1; }
  50%        { opacity: 0.3; }
}

@keyframes slideIn {
  from { opacity: 0; transform: translateX(8px); }
  to   { opacity: 1; transform: translateX(0);   }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0);   }
}

@keyframes scaleIn {
  from { opacity: 0; transform: scale(0.97); }
  to   { opacity: 1; transform: scale(1);    }
}
/* ─────────────────────────────────────────────────────────────
   Appendix refinement — dataset summary + fitted/experimental data
   Keeps the Appendix compact, readable, and responsive for both
   single and multi-dataset Batch/PFR fits.
   ───────────────────────────────────────────────────────────── */
.df-appendix-page {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  min-width: 0;
}

.df-appendix-page .df-panel {
  margin-bottom: 0;
  padding: 0;
}

.df-appendix-summary-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-md);
  flex-wrap: wrap;
  padding: var(--space-md);
  border-bottom: 1px solid var(--color-border-light);
}

.df-appendix-summary-selector-wrap {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  flex: 1 1 420px;
  min-width: 0;
}

.df-appendix-summary-selector-label {
  flex: 0 0 auto;
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--color-text-mid);
}

.df-appendix-summary-selector {
  width: min(100%, 620px);
  min-width: 0;
  padding: 9px 36px 9px 12px;
  border: 1px solid var(--color-input-border);
  border-radius: var(--radius-sm);
  background: var(--color-input-bg);
  color: var(--color-text);
  font-family: var(--font-ui);
  font-size: var(--fs-base);
  outline: none;
}

.df-appendix-summary-selector:focus {
  border-color: var(--color-accent);
  box-shadow: 0 0 0 3px var(--color-accent-dim);
}

.df-appendix-summary-meta,
.df-appendix-summary-foot {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  flex-wrap: wrap;
  color: var(--color-text-muted);
  font-size: var(--fs-xs);
  font-family: var(--font-ui);
}

.df-appendix-summary-meta {
  justify-content: flex-end;
}

.df-appendix-source-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 9px;
  border-radius: 999px;
  background: var(--color-accent-dim);
  color: var(--color-accent);
  border: 1px solid var(--color-accent-glow);
  font-weight: 700;
  white-space: nowrap;
}

.df-appendix-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-sm);
  padding: var(--space-md);
}

.df-appendix-summary-card {
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-surface);
  box-shadow: 0 1px 5px rgba(0,0,0,0.08);
}

.df-appendix-summary-label {
  margin-bottom: 5px;
  color: var(--color-text-muted);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.df-appendix-summary-value {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--color-text);
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
}

.df-appendix-summary-value--emphasis {
  color: var(--color-accent);
}

.df-appendix-summary-foot {
  padding: 0 var(--space-md) var(--space-md);
  line-height: 1.5;
}

.df-appendix-filename {
  min-width: 0;
  max-width: 46%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.df-appendix-comparison-scroll {
  width: 100%;
  max-height: min(58vh, 620px);
  overflow: auto;
  border-radius: var(--radius-md);
  scrollbar-gutter: stable both-edges;
}

.df-appendix-comparison-scroll .df-table,
.df-appendix-comparison-scroll table {
  min-width: max-content;
}

.df-appendix-comparison-scroll thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--color-panel);
}

.df-appendix-empty {
  padding: 18px var(--space-md);
  border: 1px dashed var(--color-border-light);
  border-radius: var(--radius-md);
  background: var(--color-surface);
  color: var(--color-text-muted);
  font-size: var(--fs-sm);
  text-align: center;
  line-height: 1.6;
}

.df-appendix-empty--page {
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 980px) {
  .df-appendix-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .df-appendix-summary-toolbar {
    align-items: stretch;
  }

  .df-appendix-summary-selector-wrap {
    flex-direction: column;
    align-items: stretch;
  }

  .df-appendix-summary-selector {
    width: 100%;
  }

  .df-appendix-summary-meta {
    justify-content: flex-start;
  }

  .df-appendix-summary-grid {
    grid-template-columns: 1fr;
  }

  .df-appendix-filename {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/DataFittingPage.css"],"names":[],"mappings":"AAAA;;;;;;;iEAOiE;;AAEjE,iEAAiE;;AAGjE,kEAAkE;AAClE;;;mDAGmD;AACnD;EACE;iEAC+D;EAC/D,6BAA6B,IAAI,iBAAiB;EAClD,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B,IAAI,mBAAmB;;EAEpD,8CAA8C;EAC9C,gEAAgE;EAChE,iFAAiF;EACjF,iFAAiF;EACjF,iFAAiF;;EAEjF,qDAAqD;EACrD,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;;EAEnB,8CAA8C;EAC9C,oBAAoB;;EAEpB;yDACuD;EACvD,eAAe,IAAI,6CAA6C;EAChE,eAAe,IAAI,sCAAsC;EACzD,eAAe,IAAI,sBAAsB;EACzC,eAAe,IAAI,oBAAoB;EACvC,eAAe,IAAI,wBAAwB;AAC7C;;AAEA;;;;oEAIoE;AACpE;;EAEE;6EAC2E;EAC3E,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;;EAE7B;0DACwD;EACxD,6BAA6B;EAC7B,6CAA6C;EAC7C,6CAA6C;EAC7C,6BAA6B;;EAE7B,6BAA6B;EAC7B,8CAA8C;EAC9C,6BAA6B;EAC7B,8CAA8C;EAC9C,6BAA6B;EAC7B,6BAA6B;EAC7B,6CAA6C;EAC7C,6BAA6B;EAC7B,8CAA8C;EAC9C,6BAA6B;;EAE7B;wEACsE;EACtE,6BAA6B;EAC7B,8CAA8C;EAC9C,8CAA8C;;EAE9C,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6CAA6C;EAC7C,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,sEAAsE;AACtE;EACE;wEACsE;EACtE,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,6BAA6B;EAC7B,6CAA6C;EAC7C,6CAA6C;EAC7C,6BAA6B;;EAE7B,6BAA6B;EAC7B,8CAA8C;EAC9C,6BAA6B;EAC7B,8CAA8C;EAC9C,6BAA6B;EAC7B,6BAA6B;EAC7B,6CAA6C;EAC7C,6BAA6B;EAC7B,8CAA8C;EAC9C,6BAA6B;;EAE7B,6BAA6B;EAC7B,8CAA8C;EAC9C,8CAA8C;;EAE9C,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6CAA6C;EAC7C,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB,OAAO,uCAAuC,EAAE;AAChD,IAAI,kFAAkF,EAAE;;AAExF,mEAAmE;AACnE;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,kBAAkB,IAAI,+CAA+C;EACrE,kBAAkB;AACpB;;AAEA;;;wEAGwE;AACxE;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE,6BAA6B,UAAU,EAAE,WAAW,EAAE;AACtD,6BAA6B,uBAAuB,EAAE;AACtD,6BAA6B,+BAA+B,EAAE,kBAAkB,EAAE;AAClF,kCAAkC,mCAAmC,EAAE;;AAEvE;;;;;yEAKyE;AACzE;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;AACA,oCAAoC,aAAa,EAAE,SAAS,EAAE,QAAQ,EAAE;;AAExE,kEAAkE;AAClE;kDACkD,wBAAwB,EAAE;AAC5E,mDAAmD,0BAA0B,EAAE;;AAE/E,kEAAkE;AAClE;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA,mEAAmE;AACnE;;;EAGE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;AAChC;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB,GAAG,eAAe;EACpC,4BAA4B;EAC5B,4CAA4C;EAC5C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB,GAAG,oBAAoB;EACxC,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,6DAA6D;EAC7D,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;AACA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,mEAAmE;AACnE;EACE,SAAO;EACP,gBAAgB;EAChB,wCAAwC,GAAG,eAAe;AAC5D;;AAEA,mEAAmE;AACnE;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,+BAA+B;EAC/B,wBAAwB,GAAG,eAAe;EAC1C,0CAA0C;EAC1C,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;;+DAG+D;AAC/D;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,0CAA0C;EAC1C,2CAA2C;EAC3C,kCAAkC;EAClC,UAAU;EACV,oDAAoD;EACpD,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,oCAAoC;EACpC,oBAAoB,GAAG,+BAA+B;AACxD;AACA;EACE,UAAU;EACV,oBAAoB,GAAG,+BAA+B;AACxD;;AAEA;;;;+DAI+D;AAC/D;EACE,2BAA2B;EAC3B,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,gCAAgC;EAChC,2CAA2C;EAC3C,+BAA+B;EAC/B,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;AACA,qBAAqB,iBAAiB,EAAE,mBAAmB,IAAI,cAAc,EAAE;AAC/E,qBAAqB,iBAAiB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAE/E;;;+DAG+D;AAC/D;EACE,8FAA8F;EAC9F,yCAAyC;EACzC,+BAA+B;EAC/B,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,sBAAsB;AACxB;AACA,gCAAgC,iBAAiB,EAAE,mBAAmB,IAAI,cAAc,EAAE;AAC1F,gCAAgC,iBAAiB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAE1F;EACE,WAAW;EACX,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,iBAAiB;EACjB,4CAA4C;AAC9C;AACA;EACE,iBAAiB,GAAG,eAAe;EACnC,kDAAkD;EAClD,sBAAsB;EACtB,wBAAwB;AAC1B;AACA,8BAA8B,mCAAmC,EAAE;AACnE;EACE,2BAA2B;EAC3B,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,WAAW;EACX,iBAAiB,GAAG,eAAe;EACnC,iCAAiC;EACjC,2CAA2C;EAC3C,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;EACxB,gDAAgD;EAChD,aAAa;AACf;AACA;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,qGAAoT;EACpT,2CAA2C;EAC3C,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,gDAAgD;AAClD;AACA;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA,mEAAmE;AACnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB,GAAG,eAAe;EACnC,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,kFAAkF;EAClF,mBAAmB;EACnB,aAAa;AACf;AACA,iBAAiB,sBAAsB,EAAE;;AAEzC;EACE,+BAA+B;EAC/B,WAAW;EACX,iCAAiC;EACjC,6CAA6C;AAC/C;AACA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,iCAAiC;AACnC;AACA;EACE,4BAA4B;EAC5B,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA,sDAAsD;AACtD;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,qCAAqC;AACvC;AACA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,4DAA4D;EAC5D,oBAAoB,GAAG,eAAe;EACtC,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,6CAA6C;EAC7C,eAAe;EACf,iEAAiE;EACjE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;;+DAG+D;AAC/D;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,+BAA+B;EAC/B,uCAAuC;EACvC,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;;+DAE+D;AAC/D;EACE,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA,oEAAoE;AACpE;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,+BAA+B;EAC/B,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,qEAAqE;AACrE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA,mBAAmB,oCAAoC,EAAE,2BAA2B,EAAE;AACtF,mBAAmB,oCAAoC,EAAE,gCAAgC,EAAE;AAC3F,mBAAmB,kCAAkC,IAAI,yBAAyB,IAAI;AACtF,mBAAmB,iCAAiC,KAAK,wBAAwB,KAAK;AACtF,mBAAmB,oCAAoC,EAAE,0BAA0B,GAAG;;AAEtF,oEAAoE;AACpE,iDAAiD;AACjD;EACE,eAAe;EACf,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;EACxB,2CAA2C;EAC3C,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;;AAEA,mEAAmE;AACnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,8BAA8B;EAC9B,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,oEAAoE;AACpE;EACE,WAAW;EACX,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA,mEAAmE;AACnE,aAAa,aAAa,EAAE,8BAA8B,EAAE,oBAAoB,EAAE;AAClF,aAAa,aAAa,EAAE,qCAAqC,EAAE,oBAAoB,EAAE;;AAEzF;EACE;eACa,0BAA0B,EAAE;AAC3C;;AAEA;;;;oEAIoE;AACpE;EACE,YAAY;AACd;AACA;EACE;IACE,cAAc;IACd,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,WAAW;IACX,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,QAAQ;EACV;AACF;;AAEA,oEAAoE;AACpE;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,mEAAmE;AACnE;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,YAAY,UAAU,EAAE;EACxB,aAAa,YAAY,EAAE;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,IAAI;AACjD;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,IAAI;AACjD;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,OAAO,UAAU,EAAE,mBAAmB,KAAK;AAC7C;AACA;;;;kEAIkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,2CAA2C;EAC3C,+BAA+B;EAC/B,iCAAiC;EACjC,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,0BAA0B;EAC1B,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,cAAc;EACd,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ============================================================\n   DataFittingPage.css  —  KinetiQ Data Fitting Page\n   Tracker #8:  increased font sizes & spacing throughout\n   Tracker #9:  tooltip styles (1-second hover delay)\n   Tracker #10: full-name field labels\n   Tracker #11: math subscript/superscript notation\n   Tracker #13: fitted rate equation display\n   ============================================================ */\n\n/* ─── Google Fonts ─────────────────────────────────────────── */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');\n\n/* ─── Design tokens ─────────────────────────────────────────── */\n/* NOTE: color tokens (--color-*) are defined per-theme further down\n   in the \"Dark theme (default)\" / \"Light theme\" blocks, so that\n   switching data-theme on <html> re-themes the whole app. Only\n   theme-neutral tokens live in this :root block. */\n:root {\n  /* Fitting-mode card colors (same across themes) — aligned to the\n     KinetiQ landing-page brand palette (blue / teal / accent). */\n  --color-mode-keq:     #1A3C6E;   /* kinetic-blue */\n  --color-mode-kb:      #8b55db;\n  --color-mode-unit:    #e07ba0;\n  --color-mode-lhhw:    #00C2A8;   /* kinetic-accent */\n\n  /* Typography — Tracker #8: larger base font */\n  --font-mono:   'Inter', 'JetBrains Mono', 'Fira Code', monospace;\n  --font-ui:     'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  --font-brand:  'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  --font-serif:  'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n\n  /* Spacing scale — Tracker #8: generously increased */\n  --space-xs:    6px;\n  --space-sm:    10px;\n  --space-md:    16px;\n  --space-lg:    24px;\n  --space-xl:    36px;\n\n  /* Border radius */\n  --radius-sm:   6px;\n  --radius-md:   10px;\n  --radius-lg:   14px;\n\n  /* Sidebar offset (must match Sidebar width) */\n  --sidebar-w:   242px;\n\n  /* Font-size scale — replaces ad-hoc inline fontSize:10/11 values.\n     Nothing in the app should go below --fs-xs (12px). */\n  --fs-xs:   12px;   /* table cells, dense data grids, footnotes */\n  --fs-sm:   13px;   /* field labels, secondary/help text */\n  --fs-base: 15px;   /* body text, inputs */\n  --fs-lg:   18px;   /* section headers */\n  --fs-xl:   22px;   /* panel / page titles */\n}\n\n/* ─── Dark theme (default) ──────────────────────────────────────\n   Client decision: dark background + white font on the main panel,\n   sidebar was already dark. Avoid pairing dark bg with coloured\n   font — text stays white/near-white. Light theme remains available\n   via the theme toggle (data-theme=\"light\" on <html>). ────────── */\n:root,\n[data-theme=\"dark\"] {\n  /* Backgrounds — deep navy family, matching kinetic-dark (#0D1F35) from\n     the KinetiQ landing page instead of the previous slate/graphite tones. */\n  --color-bg:           #0B1826;\n  --color-surface:      #0F2135;\n  --color-panel:        #142A44;\n  --color-card:         #12253D;\n  --color-shell:        #0d1a2c00;\n  --color-nav:          #081422;\n  --color-code-bg:      #081420;\n\n  /* Brand accent — kinetic-accent teal-green, matches the landing-page\n     CTA / highlight color (was a plain green, #34c15e). */\n  --color-accent:       #00C2A8;\n  --color-accent-dim:   rgba(0, 194, 168, 0.14);\n  --color-accent-glow:  rgba(0, 194, 168, 0.32);\n  --color-accent-hover: #00A88F;\n\n  --color-success:      #2FBE84;\n  --color-success-dim:  rgba(47, 190, 132, 0.14);\n  --color-warning:      #F4A261;\n  --color-warning-dim:  rgba(244, 162, 97, 0.16);\n  --color-warning-dark: #F4A261;\n  --color-error:        #f2555a;\n  --color-error-dim:    rgba(242, 85, 90, 0.16);\n  --color-cyan:         #2FB9D9;\n  --color-cyan-dim:     rgba(47, 185, 217, 0.14);\n  --color-purple:       #a97bf0;\n\n  /* Unified toggle-pill color — kinetic-teal, matches the landing page's\n     secondary brand color so toggles read as part of the same system. */\n  --color-toggle:       #0B8DA6;\n  --color-toggle-dim:   rgba(11, 141, 166, 0.18);\n  --color-toggle-glow:  rgba(11, 141, 166, 0.38);\n\n  --color-border:       #1F3350;\n  --color-border-light: #2A415F;\n  --color-border-mid:   #17263D;\n\n  --color-text:         #F0F7FA;\n  --color-text-muted:   #93A9BC;\n  --color-text-mid:     #B9CBD8;\n  --color-text-dim:     #64768A;\n\n  --color-tab-active:   #00C2A8;\n  --color-tab-hover:    #16283F;\n  --color-nav-active:   rgba(0, 194, 168, 0.16);\n  --color-input-bg:     #0D1F32;\n  --color-input-border: #1F3350;\n  --color-tag:          #2FB9D9;\n}\n\n/* ─── Light theme (opt-in via toggle) ───────────────────────────── */\n[data-theme=\"light\"] {\n  /* Light theme now mirrors the KinetiQ landing page directly:\n     --kinetic-light bg, white cards, blue headings, teal/accent CTAs. */\n  --color-bg:           #F0F7FA;\n  --color-surface:      #FFFFFF;\n  --color-panel:        #E3F2F0;\n  --color-card:         #FFFFFF;\n  --color-shell:        #F5FAFB;\n  --color-nav:          #EAF3F6;\n  --color-code-bg:      #F7FBFC;\n\n  --color-accent:       #00C2A8;\n  --color-accent-dim:   rgba(0, 194, 168, 0.10);\n  --color-accent-glow:  rgba(0, 194, 168, 0.25);\n  --color-accent-hover: #049885;\n\n  --color-success:      #1E9E6C;\n  --color-success-dim:  rgba(30, 158, 108, 0.10);\n  --color-warning:      #E8973F;\n  --color-warning-dim:  rgba(232, 151, 63, 0.12);\n  --color-warning-dark: #C66A2E;\n  --color-error:        #e03535;\n  --color-error-dim:    rgba(224, 53, 53, 0.10);\n  --color-cyan:         #0B8DA6;\n  --color-cyan-dim:     rgba(11, 141, 166, 0.10);\n  --color-purple:       #8b55db;\n\n  --color-toggle:       #0B8DA6;\n  --color-toggle-dim:   rgba(11, 141, 166, 0.10);\n  --color-toggle-glow:  rgba(11, 141, 166, 0.28);\n\n  --color-border:       #D6E4EC;\n  --color-border-light: #E8F1F6;\n  --color-border-mid:   #C3D6E0;\n\n  --color-text:         #0D1F35;\n  --color-text-muted:   #6B7A8D;\n  --color-text-mid:     #45566A;\n  --color-text-dim:     #A8B8C4;\n\n  --color-tab-active:   #00C2A8;\n  --color-tab-hover:    #E3F2F0;\n  --color-nav-active:   rgba(0, 194, 168, 0.12);\n  --color-input-bg:     #ffffff;\n  --color-input-border: #D6E4EC;\n  --color-tag:          #0B8DA6;\n}\n\n/* Smooth theme switch */\nhtml { transition: background-color 160ms ease; }\n* { transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease; }\n\n/* ─── Global Reset ───────────────────────────────────────────── */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml,\nbody {\n  background:   var(--color-bg);\n  color:        var(--color-text);\n  height:       100%;\n  overflow:     hidden;\n  font-family:  var(--font-ui);\n  font-size:    16px;   /* Aligned with TutorialsDashboard Inter base */\n  line-height:  1.65;\n}\n\n/* Guard against parent layout/router wrappers (e.g. #root, #app) that\n   don't inherit height/overflow constraints — without this, the page\n   can grow taller than the viewport and the *browser* scrolls instead\n   of the intended internal panels, hiding the top nav under the fold. */\n#root,\n#app {\n  height:   100%;\n  overflow: hidden;\n}\n\n/* ─── Scrollbar ──────────────────────────────────────────────── */\n::-webkit-scrollbar        { width: 5px; height: 5px; }\n::-webkit-scrollbar-track  { background: transparent; }\n::-webkit-scrollbar-thumb  { background: var(--color-border); border-radius: 3px; }\n::-webkit-scrollbar-thumb:hover { background: var(--color-border-mid); }\n\n/* ─── KaTeX equation blocks — no scroll ─────────────────────────\n   react-katex's <BlockMath> renders a `.katex-display` span, and KaTeX's\n   own stylesheet gives that element `overflow-x: auto` by default — this\n   is what was actually producing the left/right scrollbar under the Rate\n   Equation / Arrhenius / Expressions-used boxes, independent of any\n   overflow setting on our own wrapping <div>. Force it off everywhere. */\n.katex-display {\n  overflow-x: visible !important;\n  overflow-y: visible !important;\n}\n.katex-display::-webkit-scrollbar { display: none; height: 0; width: 0; }\n\n/* ─── Number input — hide spin buttons ──────────────────────── */\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button { -webkit-appearance: none; }\ninput[type='number']                             { -moz-appearance: textfield; }\n\n/* ─── Select option theming ─────────────────────────────────── */\nselect option {\n  background: var(--color-surface);\n  color:      var(--color-text);\n}\n\n/* ─── Focus rings ────────────────────────────────────────────── */\nbutton:focus-visible,\ninput:focus-visible,\nselect:focus-visible {\n  outline:        2px solid var(--color-accent);\n  outline-offset: 2px;\n}\n\n/* ─── Sidebar layout offset ─────────────────────────────────── */\n.df-page-root {\n  margin-left: var(--sidebar-w);\n  height: 100vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ─── Panel shell ────────────────────────────────────────────── */\n.df-shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--color-shell);\n}\n\n/* ─── Top nav bar ────────────────────────────────────────────── */\n.df-nav {\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n  padding: 10px 20px;  /* Tracker #8 */\n  background: var(--color-nav);\n  border-bottom: 1px solid var(--color-border);\n  flex-shrink: 0;\n  overflow-x: auto;\n}\n\n.df-nav-tab {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 18px;  /* Tracker #6 & #8 */\n  border-radius: var(--radius-sm);\n  border: 1px solid transparent;\n  background: none;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: var(--font-ui);\n  color: var(--color-text-muted);\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n  white-space: nowrap;\n  text-decoration: none;\n}\n.df-nav-tab:hover {\n  background: var(--color-tab-hover);\n  color: var(--color-text);\n}\n.df-nav-tab--active {\n  background: var(--color-nav-active);\n  color: var(--color-accent);\n  font-weight: 600;\n  border-color: rgba(40, 167, 69, 0.25);\n}\n\n/* ─── Main content area ──────────────────────────────────────── */\n.df-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: var(--space-lg) var(--space-lg);  /* Tracker #8 */\n}\n\n/* ─── Panel cards ────────────────────────────────────────────── */\n.df-panel {\n  background: var(--color-card);\n  border: 1px solid var(--color-border-light);\n  border-radius: var(--radius-lg);\n  padding: var(--space-lg);  /* Tracker #8 */\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);\n  margin-bottom: var(--space-lg);\n  animation: fadeIn 0.25s ease;\n}\n\n.df-panel-title {\n  font-family: var(--font-ui);\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--color-text);\n  letter-spacing: -0.1px;\n  margin-bottom: var(--space-md);\n}\n\n.df-panel-subtitle {\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--color-text-muted);\n  margin-bottom: var(--space-lg);\n  line-height: 1.65;\n}\n\n/* ─── Form fields — Tracker #8: increased label size & spacing ── */\n.df-field-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n  margin-bottom: var(--space-md);\n}\n\n.df-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-mid);\n  letter-spacing: 0.01em;\n  font-family: var(--font-ui);\n}\n\n/* ─────────────────────────────────────────────────────────────\n   Tooltip system — Tracker #9\n   1-second hover delay for all [data-tooltip] elements\n───────────────────────────────────────────────────────────── */\n[data-tooltip] {\n  position: relative;\n  cursor: help;\n}\n[data-tooltip]::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%) scale(0.9);\n  background: #1a2332;\n  color: #cdd9e5;\n  font-size: 13px;\n  font-family: var(--font-ui);\n  font-weight: 400;\n  line-height: 1.45;\n  padding: 7px 12px;\n  border-radius: 7px;\n  white-space: pre-wrap;\n  max-width: 260px;\n  min-width: 120px;\n  text-align: center;\n  pointer-events: none;\n  z-index: 1000;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  /* 1-second delay per Tracker #9 */\n  opacity: 0;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n  transition-delay: 0s;\n}\n[data-tooltip]::before {\n  content: '';\n  position: absolute;\n  bottom: calc(100% + 2px);\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: #1a2332;\n  pointer-events: none;\n  z-index: 1000;\n  opacity: 0;\n  transition: opacity 0.15s ease;\n  transition-delay: 0s;\n}\n[data-tooltip]:hover::after {\n  opacity: 1;\n  transform: translateX(-50%) scale(1);\n  transition-delay: 1s;  /* Tracker #9: 1-second delay */\n}\n[data-tooltip]:hover::before {\n  opacity: 1;\n  transition-delay: 1s;  /* Tracker #9: 1-second delay */\n}\n\n/* ─────────────────────────────────────────────────────────────\n   Math notation — Tracker #11\n   Subscripts & superscripts for rate equations\n   e.g. kf, xa\n───────────────────────────────────────────────────────────── */\n.df-math {\n  font-family: var(--font-ui);\n  font-size: 14px;\n  color: var(--color-text);\n  display: inline-flex;\n  align-items: baseline;\n  gap: 1px;\n}\n.df-math sub {\n  font-size: 0.72em;\n  vertical-align: sub;\n  line-height: 0;\n}\n.df-math sup {\n  font-size: 0.72em;\n  vertical-align: super;\n  line-height: 0;\n}\n.df-math-block {\n  font-family: var(--font-ui);\n  font-size: 14px;\n  background: var(--color-code-bg);\n  border: 1px solid var(--color-border-light);\n  border-radius: var(--radius-sm);\n  padding: 10px 14px;\n  color: var(--color-text);\n  line-height: 1.8;\n  overflow-x: auto;\n}\n.df-math-block sub { font-size: 0.72em; vertical-align: sub;   line-height: 0; }\n.df-math-block sup { font-size: 0.72em; vertical-align: super; line-height: 0; }\n\n/* ─────────────────────────────────────────────────────────────\n   Fitted rate equation display — Tracker #13\n   Shows model form + fitted parameter values together\n───────────────────────────────────────────────────────────── */\n.df-rate-equation-card {\n  background: linear-gradient(135deg, rgba(40, 167, 69, 0.06) 0%, rgba(10, 181, 226, 0.04) 100%);\n  border: 1px solid rgba(40, 167, 69, 0.22);\n  border-radius: var(--radius-md);\n  padding: var(--space-md) var(--space-lg);\n  margin-bottom: var(--space-md);\n  position: relative;\n  overflow: hidden;\n}\n.df-rate-equation-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 3px;\n  background: var(--color-accent);\n  border-radius: 3px 0 0 3px;\n}\n.df-rate-equation-label {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--color-accent);\n  font-family: var(--font-ui);\n  margin-bottom: 8px;\n}\n.df-rate-equation-formula {\n  font-family: var(--font-ui);\n  font-size: 15px;\n  color: var(--color-text);\n  line-height: 2;\n  letter-spacing: 0.01em;\n}\n.df-rate-equation-formula sub { font-size: 0.72em; vertical-align: sub;   line-height: 0; }\n.df-rate-equation-formula sup { font-size: 0.72em; vertical-align: super; line-height: 0; }\n\n.df-param-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: var(--space-sm);\n  font-size: 14px;\n  font-family: var(--font-ui);\n}\n.df-param-table th {\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--color-text-muted);\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--color-border);\n}\n.df-param-table td {\n  padding: 9px 12px;  /* Tracker #8 */\n  border-bottom: 1px solid var(--color-border-light);\n  vertical-align: middle;\n  color: var(--color-text);\n}\n.df-param-table tr:hover td { background: rgba(40, 167, 69, 0.04); }\n.df-param-value {\n  font-family: var(--font-ui);\n  font-size: 14px;\n  color: var(--color-accent);\n  font-weight: 600;\n}\n\n/* ─── Inputs ──────────────────────────────────────────────────── */\n.df-input {\n  width: 100%;\n  padding: 9px 12px;  /* Tracker #8 */\n  background: var(--color-input-bg);\n  border: 1px solid var(--color-input-border);\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  font-family: var(--font-ui);\n  color: var(--color-text);\n  transition: border-color 0.15s, box-shadow 0.15s;\n  outline: none;\n}\n.df-input:focus {\n  border-color: var(--color-accent);\n  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.12);\n}\n\n.df-select {\n  appearance: none;\n  width: 100%;\n  padding: 9px 34px 9px 12px;\n  background: var(--color-input-bg) url(\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%236a5e58' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\") no-repeat right 12px center;\n  border: 1px solid var(--color-input-border);\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  font-family: var(--font-ui);\n  color: var(--color-text);\n  cursor: pointer;\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n.df-select:focus {\n  border-color: var(--color-accent);\n  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.12);\n}\n\n/* ─── Buttons ────────────────────────────────────────────────── */\n.df-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 18px;  /* Tracker #8 */\n  border-radius: var(--radius-sm);\n  border: 1px solid transparent;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: var(--font-ui);\n  letter-spacing: 0.01em;\n  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s, transform 0.1s;\n  white-space: nowrap;\n  outline: none;\n}\n.df-btn:active { transform: scale(0.98); }\n\n.df-btn--primary {\n  background: var(--color-accent);\n  color: #fff;\n  border-color: var(--color-accent);\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.28);\n}\n.df-btn--primary:hover {\n  background: var(--color-accent-hover);\n  border-color: var(--color-accent-hover);\n  box-shadow: 0 4px 14px rgba(40, 167, 69, 0.36);\n}\n\n.df-btn--secondary {\n  background: var(--color-surface);\n  color: var(--color-text-mid);\n  border-color: var(--color-border);\n}\n.df-btn--secondary:hover {\n  background: var(--color-nav);\n  border-color: var(--color-border-mid);\n  color: var(--color-text);\n}\n\n/* Tracker #3: renamed 'Auto-fill from Previous Run' */\n.df-btn--autofill {\n  background: rgba(40, 167, 69, 0.08);\n  color: var(--color-accent);\n  border-color: rgba(40, 167, 69, 0.25);\n}\n.df-btn--autofill:hover {\n  background: rgba(40, 167, 69, 0.14);\n  border-color: rgba(40, 167, 69, 0.4);\n}\n\n/* ─── Fitting mode cards ─────────────────────────────────────── */\n.df-mode-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: var(--space-md);  /* Tracker #8 */\n  margin-bottom: var(--space-lg);\n}\n\n.df-mode-card {\n  padding: var(--space-md);\n  border-radius: var(--radius-md);\n  border: 1.5px solid var(--color-border-light);\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;\n  position: relative;\n  overflow: hidden;\n  background: var(--color-card);\n}\n.df-mode-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n}\n.df-mode-card--active {\n  border-color: var(--color-accent);\n  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.12);\n}\n.df-mode-card-name {\n  font-size: 14px;\n  font-weight: 600;\n  font-family: var(--font-ui);\n  margin-bottom: 4px;\n}\n.df-mode-card-desc {\n  font-size: 13px;\n  color: var(--color-text-muted);\n  line-height: 1.4;\n}\n\n/* ─────────────────────────────────────────────────────────────\n   Reaction type toggle — Tracker #17\n   Reversible / Irreversible\n───────────────────────────────────────────────────────────── */\n.df-reaction-toggle {\n  display: flex;\n  gap: var(--space-sm);\n  margin-bottom: var(--space-md);\n}\n\n.df-reaction-toggle-btn {\n  flex: 1;\n  padding: 10px 16px;\n  border-radius: var(--radius-sm);\n  border: 1.5px solid var(--color-border);\n  background: var(--color-surface);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: var(--font-ui);\n  color: var(--color-text-muted);\n  text-align: center;\n  transition: all 0.15s;\n}\n.df-reaction-toggle-btn:hover {\n  border-color: var(--color-accent);\n  color: var(--color-accent);\n  background: var(--color-accent-dim);\n}\n.df-reaction-toggle-btn--active {\n  background: var(--color-accent-dim);\n  border-color: var(--color-accent);\n  color: var(--color-accent);\n  font-weight: 600;\n  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.12);\n}\n\n/* ─────────────────────────────────────────────────────────────\n   NIST component search row — Tracker #18 & #19\n───────────────────────────────────────────────────────────── */\n.df-nist-row {\n  display: flex;\n  gap: var(--space-sm);\n  align-items: flex-end;\n  flex-wrap: wrap;\n  margin-bottom: var(--space-md);\n}\n.df-nist-badge {\n  font-size: 13px;\n  font-family: var(--font-ui);\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  padding: 3px 8px;\n  border-radius: 4px;\n  background: var(--color-cyan-dim);\n  color: var(--color-cyan);\n  border: 1px solid rgba(10, 181, 226, 0.25);\n}\n\n/* ─── Graphs / Plots ──────────────────────────────────────────── */\n.df-graph-container {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border-light);\n  border-radius: var(--radius-md);\n  padding: var(--space-md);\n  min-height: 300px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n/* ─── Status / info tags ────────────────────────────────────────  */\n.df-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  font-weight: 700;\n  font-family: var(--font-ui);\n  padding: 3px 9px;\n  border-radius: 5px;\n  letter-spacing: 0.03em;\n}\n.df-tag--success { background: var(--color-success-dim); color: var(--color-success); }\n.df-tag--warning { background: var(--color-warning-dim); color: var(--color-warning-dark); }\n.df-tag--error   { background: var(--color-error-dim);   color: var(--color-error);   }\n.df-tag--info    { background: var(--color-cyan-dim);    color: var(--color-cyan);    }\n.df-tag--purple  { background: rgba(139, 85, 219, 0.10); color: var(--color-purple);  }\n\n/* ─── Appendix — Tracker #5: remove petBOA/OpenMKM from main UI ─ */\n/* These are shown only in the appendix section */\n.df-appendix-footnote {\n  font-size: 13px;\n  color: var(--color-text-muted);\n  font-family: var(--font-ui);\n  padding: var(--space-md);\n  border: 1px solid var(--color-border-light);\n  border-radius: var(--radius-sm);\n  background: var(--color-shell);\n  margin-top: var(--space-md);\n  line-height: 1.6;\n}\n.df-appendix-footnote strong {\n  color: var(--color-text-mid);\n}\n\n/* ─── Reaction Rate Constants label — Tracker #2 ─────────────── */\n.df-rrc-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--color-text-muted);\n  font-family: var(--font-ui);\n  margin-bottom: var(--space-sm);\n}\n.df-rrc-badge::after {\n  content: 'Compatible with Aspen, DWSim';\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.03em;\n  color: var(--color-text-dim);\n  background: var(--color-shell);\n  border: 1px solid var(--color-border-light);\n  border-radius: 4px;\n  padding: 2px 7px;\n  text-transform: none;\n}\n\n/* ─── Divider ─────────────────────────────────────────────────── */\n.df-divider {\n  height: 1px;\n  background: var(--color-border-light);\n  margin: var(--space-md) 0;\n}\n\n/* ─── Grid helpers ───────────────────────────────────────────── */\n.df-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: var(--space-md); }\n.df-grid-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: var(--space-md); }\n\n@media (max-width: 860px) {\n  .df-grid-2,\n  .df-grid-3 { grid-template-columns: 1fr; }\n}\n\n/* ─── Reset / Stop / Run Fitting action row ─────────────────────\n   Sits in a single flex row (see DataFittingPage.jsx) that already\n   wraps on its own via flex-wrap; these rules just make each button\n   shrink and reflow cleanly instead of overflowing on small screens,\n   and let \"Run Fitting\" grow to fill the row once it wraps alone. */\n.df-fit-actions {\n  row-gap: 8px;\n}\n@media (max-width: 640px) {\n  .df-fit-btn {\n    flex: 1 1 auto;\n    font-size: 11px !important;\n    padding: 6px 10px !important;\n  }\n}\n@media (max-width: 480px) {\n  .df-fit-actions {\n    width: 100%;\n    justify-content: stretch;\n  }\n  .df-fit-btn {\n    flex: 1 1 30%;\n    min-width: 0;\n    text-align: center;\n  }\n  .df-fit-btn-run {\n    flex-basis: 100%;\n    order: 3;\n  }\n}\n\n/* ─── Loading spinner ─────────────────────────────────────────── */\n.df-spinner {\n  width: 22px;\n  height: 22px;\n  border: 2.5px solid var(--color-border);\n  border-top-color: var(--color-accent);\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n  display: inline-block;\n}\n\n/* ─── Animations ─────────────────────────────────────────────── */\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes pulse-dot {\n  0%,  100% { opacity: 1; }\n  50%        { opacity: 0.3; }\n}\n\n@keyframes slideIn {\n  from { opacity: 0; transform: translateX(8px); }\n  to   { opacity: 1; transform: translateX(0);   }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(4px); }\n  to   { opacity: 1; transform: translateY(0);   }\n}\n\n@keyframes scaleIn {\n  from { opacity: 0; transform: scale(0.97); }\n  to   { opacity: 1; transform: scale(1);    }\n}\n/* ─────────────────────────────────────────────────────────────\n   Appendix refinement — dataset summary + fitted/experimental data\n   Keeps the Appendix compact, readable, and responsive for both\n   single and multi-dataset Batch/PFR fits.\n   ───────────────────────────────────────────────────────────── */\n.df-appendix-page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  min-width: 0;\n}\n\n.df-appendix-page .df-panel {\n  margin-bottom: 0;\n  padding: 0;\n}\n\n.df-appendix-summary-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-md);\n  flex-wrap: wrap;\n  padding: var(--space-md);\n  border-bottom: 1px solid var(--color-border-light);\n}\n\n.df-appendix-summary-selector-wrap {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  flex: 1 1 420px;\n  min-width: 0;\n}\n\n.df-appendix-summary-selector-label {\n  flex: 0 0 auto;\n  font-size: var(--fs-sm);\n  font-weight: 700;\n  color: var(--color-text-mid);\n}\n\n.df-appendix-summary-selector {\n  width: min(100%, 620px);\n  min-width: 0;\n  padding: 9px 36px 9px 12px;\n  border: 1px solid var(--color-input-border);\n  border-radius: var(--radius-sm);\n  background: var(--color-input-bg);\n  color: var(--color-text);\n  font-family: var(--font-ui);\n  font-size: var(--fs-base);\n  outline: none;\n}\n\n.df-appendix-summary-selector:focus {\n  border-color: var(--color-accent);\n  box-shadow: 0 0 0 3px var(--color-accent-dim);\n}\n\n.df-appendix-summary-meta,\n.df-appendix-summary-foot {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  flex-wrap: wrap;\n  color: var(--color-text-muted);\n  font-size: var(--fs-xs);\n  font-family: var(--font-ui);\n}\n\n.df-appendix-summary-meta {\n  justify-content: flex-end;\n}\n\n.df-appendix-source-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 9px;\n  border-radius: 999px;\n  background: var(--color-accent-dim);\n  color: var(--color-accent);\n  border: 1px solid var(--color-accent-glow);\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.df-appendix-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--space-sm);\n  padding: var(--space-md);\n}\n\n.df-appendix-summary-card {\n  min-width: 0;\n  padding: 12px 14px;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  background: var(--color-surface);\n  box-shadow: 0 1px 5px rgba(0,0,0,0.08);\n}\n\n.df-appendix-summary-label {\n  margin-bottom: 5px;\n  color: var(--color-text-muted);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.df-appendix-summary-value {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--color-text);\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.4;\n}\n\n.df-appendix-summary-value--emphasis {\n  color: var(--color-accent);\n}\n\n.df-appendix-summary-foot {\n  padding: 0 var(--space-md) var(--space-md);\n  line-height: 1.5;\n}\n\n.df-appendix-filename {\n  min-width: 0;\n  max-width: 46%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.df-appendix-comparison-scroll {\n  width: 100%;\n  max-height: min(58vh, 620px);\n  overflow: auto;\n  border-radius: var(--radius-md);\n  scrollbar-gutter: stable both-edges;\n}\n\n.df-appendix-comparison-scroll .df-table,\n.df-appendix-comparison-scroll table {\n  min-width: max-content;\n}\n\n.df-appendix-comparison-scroll thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: var(--color-panel);\n}\n\n.df-appendix-empty {\n  padding: 18px var(--space-md);\n  border: 1px dashed var(--color-border-light);\n  border-radius: var(--radius-md);\n  background: var(--color-surface);\n  color: var(--color-text-muted);\n  font-size: var(--fs-sm);\n  text-align: center;\n  line-height: 1.6;\n}\n\n.df-appendix-empty--page {\n  min-height: 260px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (max-width: 980px) {\n  .df-appendix-summary-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .df-appendix-summary-toolbar {\n    align-items: stretch;\n  }\n\n  .df-appendix-summary-selector-wrap {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .df-appendix-summary-selector {\n    width: 100%;\n  }\n\n  .df-appendix-summary-meta {\n    justify-content: flex-start;\n  }\n\n  .df-appendix-summary-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .df-appendix-filename {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
